import { createContext } from "react";
import { OrderContextProps } from "./types.ts";

export const OrderContext = createContext<OrderContextProps>({} as OrderContextProps);
